// src/pages/AboutUs.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import aboutSec1 from '../assets/img/core-img/about-sec1.png';
import aboutSec2 from '../assets/img/core-img/about-sec2.jpg';
import test1 from '../assets/img/test-img/1.jpg';
import test2 from '../assets/img/test-img/2.jpg';
import test3 from '../assets/img/test-img/3.jpg';

export default function AboutUs() {
  useEffect(() => {
    const $ = window.$;

    // — Owl Carousel (for testimonial slider) with numbered dots —
    if ($ && $.fn.owlCarousel) {
      const $slider = $('.client_slides');
      $slider.owlCarousel({
        items: 2,
        loop: true,
        margin: 30,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        responsive: {
          0:   { items: 1 },
          768: { items: 2 }
        }
      })
      // after init or any change, replace each dot’s text with a zero-padded index
      .on('initialized.owl.carousel changed.owl.carousel', function() {
        $slider.find('.owl-dot').each((i, dot) => {
          $(dot).text(String(i + 1).padStart(2, '0'));
        });
      });
    }

    // — FAQ accordion binding & initial open state —
    if ($) {
      const $dts = $('.info-faq-area dt');
      $dts.removeClass('active').next('dd').hide();
      const $first = $dts.first();
      $first.addClass('active').next('dd').show();

      $dts.off('click').on('click', function() {
        const $dt = $(this);
        $dt.toggleClass('active')
           .next('dd').stop(true, true).slideToggle(300);
        $dt.siblings('dt').removeClass('active')
           .next('dd').stop(true, true).slideUp(300);
      });
    }

    // — Re-init WOW.js (for fadeInUp animations) —
    if (window.WOW) new window.WOW().init();
  }, []);

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcumb-area clearfix auto-init">
        <div className="breadcumb-content">
          <div className="container h-100">
            <div className="row h-100 align-items-center">
              <div className="col-12">
                <nav aria-label="breadcrumb" className="breadcumb--con text-center">
                  <h2 className="w-text title wow fadeInUp" data-wow-delay="0.2s">About Us</h2>
                  <ol className="breadcrumb justify-content-center wow fadeInUp" data-wow-delay="0.4s">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">About Us</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* About Us Area */}
      <section className="about-us-area section-padding-100 relative" id="about">
        <div className="container">
          <div className="row align-items-center">
            {/* Text */}
            <div className="col-12 col-lg-6 col-md-12">
              <div className="who-we-contant">
                <div className="promo-section">
                  <h3 className="special-head">About Ardent Translations</h3>
                </div>
                <h4 className="d-blue bold fadeInUp" data-wow-delay="0.3s">Leaders in Translation & Localization</h4>
                <p className="fadeInUp" data-wow-delay="0.4s">
                 Ardent Translations is a one-stop translation and content partner serving clients across India. <strong>We specialize in Indic languages and global rare languages</strong>, with our in-house linguists and project managers working as an extension of your team, delivering language solutions that meet rigorous international standards.

                </p>
                  <p className="fadeInUp" data-wow-delay="0.4s">
               Mission: To be more than a vendor: to become your trusted partner for every multilingual need, from the first brief to the final deliverable, with special expertise in underserved linguistic communities.
                </p>
              </div>
            </div>
            {/* Image */}
            <div className="col-12 col-lg-6 col-md-12 no-padding-left">
              <div className="welcome-meter about-sec-wrapper wow fadeInUp mt-s" data-wow-delay="0.4s">
                <img
                  src={aboutSec1}
                  className="about-i"
                  alt="Translation services"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Timeline */}
      <div className="faq-timeline-area section-padding-100" id="faq">
        <div className="container">
          <div className="section-heading text-center">
            <span>Frequently Asked</span>
            <h2 className="d-blue bold fadeInUp" data-wow-delay="0.3s">Translation FAQs</h2>
            <p className="fadeInUp" data-wow-delay="0.4s">
              Answers to common questions about our translation services.
            </p>
          </div>
          <div className="row align-items-center">
            {/* Q&A */}
            <div className="col-12 col-lg-6 offset-lg-0 col-md-8 offset-md-2 col-sm-10 offset-sm-1">
              <div className="info-faq-area mt-s">
                <dl style={{ marginBottom: 0 }}>
                  {[
                    { q: 'What turnaround time can I expect?', a: 'Most projects are completed within 1–3 business days depending on length and complexity.' },
                    { q: 'How do you ensure translation quality?', a: 'Every document undergoes a two-step review by native-speaking linguists and editors.' },
                    { q: 'Can you handle specialized industries?', a: 'Yes, we serve legal, medical, technical, marketing, and other industry sectors.' },
                    { q: 'Do you offer desktop publishing (DTP)?', a: 'We provide DTP to preserve layout and design in translated documents.' }
                  ].map((item, i) => (
                    <React.Fragment key={i}>
                      <dt className="wave fadeInUp" data-wow-delay={`${0.2 + 0.1 * i}s`}>{item.q}</dt>
                      <dd className="fadeInUp" data-wow-delay={`${0.3 + 0.1 * i}s`}><p>{item.a}</p></dd>
                    </React.Fragment>
                  ))}
                </dl>
              </div>
            </div>
            {/* FAQ Image */}
            <div className="col-12 col-lg-6">
              <div className="welcome-meter about-sec-wrapper wow fadeInUp" data-wow-delay="0.4s">
                <img src={aboutSec2} alt="FAQ" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Testimonials Slider */}
      <section className="testimonials-area map-bg map-before section-padding-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-4">
              <div className="section-heading text-left">
                <span>What Clients Say</span>
                <h2 className="d-blue bold bl-text wow fadeInUp" data-wow-delay="0.3s">
                  Loved By Our Clients
                </h2>
                <p className="wow fadeInUp" data-wow-delay="0.4s">
                  Hear how Ardent Translations has helped businesses communicate globally.
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-8">
              <div className="client_slides owl-carousel">
                {[
                  { img: test1, text: `"Ardent Translations translated our entire product manual into five languages. Excellent quality and fast delivery."`, name: 'Tech Solutions Ltd', role: 'Product Manager' },
                  { img: test2, text: `"The localization of our website boosted our international sales by 30%. Outstanding cultural adaptation."`, name: 'GlobalShop', role: 'Marketing Director' },
                  { img: test3, text: `"Their medical translation services are incredibly accurate and reliable. Perfect for specialized content."`, name: 'HealthCare Corp', role: 'Clinical Lead' }
                ].map((t, i) => (
                  <div className="single-testimonial text-center" key={i}>
                    <div className="testimonial_image">
                      <img src={t.img} alt={t.name} />
                    </div>
                    <div className="testimonial-description">
                      <div className="testimonial_text"><p>{t.text}</p></div>
                      <div className="admin_text"><h5>{t.name}</h5><p>{t.role}</p></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}